export enum FrontendUrls {
  connect = '/connect',
  signin = '/signin',
  signup = '/signup',
  oauthAuthorize = '/oauth/authorize',
  slackPostInstall = '/slack/post-installation',
  installSlackBot = '/slack/install-bot',
  kats = '/kats-kingdom',
  externalConnect = '/external-connect',
  dashboard = '/app/dashboard',
  userDashboard = '/app/my-dashboard',
  outOfOffice = '/app/out-of-office',
  companyDetails = '/company-details',
  personalInfo = '/personal-info',
  selectPlan = '/select-plan',
  microsoftSaasCreateCompany = '/microsoft-saas/create-company',
  microsoftSaasCreateCompanyWelcome = '/microsoft-saas/create-company/welcome',
  microsoftSaasCreateCompanyDetails = '/microsoft-saas/create-company/company-details',
  microsoftSaasCreateCompanyAssignLicenses = '/microsoft-saas/create-company/assign-licenses',
  microsoftSaasCreateCompanySetupBot = '/microsoft-saas/create-company/setup-ms-bot',
  subscription = '/subscription',
  billing = '/app/settings/billing',
  users = '/users',
  importEmailUsers = '/users/import-email-users',
  googlePermissions = '/vt-google-permissions',
  accountSettings = '/app/settings/personal',
  energyLevel = '/app/energy-level',
  calendarPage = '/app/calendar',
  calendarSyncPage = '/app/calendar/sync',
  calendarSyncPageIcalCreate = '/app/calendar/sync/ical/create',
  calendarSyncPageIcalSummary = '/app/calendar/sync/ical/summary',
  calendarSyncPageGoogleConnect = '/app/calendar/sync/google/connect',
  calendarSyncPageGoogleCreate = '/app/calendar/sync/google/create',
  calendarSyncPageGoogleUpdate = '/app/calendar/sync/google/update',
  calendarSyncPageOutlookConnect = '/app/calendar/sync/outlook/connect',
  calendarSyncPageOutlookCreate = '/app/calendar/sync/outlook/create',
  calendarSyncPageOutlookUpdate = '/app/calendar/sync/outlook/update',
  calendarSyncPageGoogleReconnect = '/app/calendar/sync/google/reconnect',
  calendarSyncPageOutlookReconnect = '/app/calendar/sync/outlook/reconnect',
  aiAssistant = '/app/ai-assistant',
  reports = '/app/reports',
  companyLogs = '/app/reports/company-logs',
  scheduledReports = '/app/reports/scheduled-reports',
  addons = '/app/add-ons',
  locations = '/app/settings/locations',
  departments = '/app/settings/departments',
  leaveTypes = '/app/settings/leave-types',
  leavePolicies = '/app/settings/leave-policies',
  imports = '/app/imports',
  import = '/app/import',
  wallchart = '/app/wallchart',
  notifications = '/app/notifications',
}
